import React from 'react';
import Icon from '../../../components/AppIcon';

const LocationSection = () => {
  const locationFeatures = [
    {
      id: 1,
      icon: 'School',
      title: 'Centros Educativos',
      description: 'Colegios y universidades a 5-10 minutos',
      distance: '2.5 km'
    },
    {
      id: 2,
      icon: 'ShoppingCart',
      title: 'Centros Comerciales',
      description: 'Mall Plaza y Real Plaza cercanos',
      distance: '3.8 km'
    },
    {
      id: 3,
      icon: 'Hospital',
      title: 'Centros de Salud',
      description: 'Hospitales y clínicas de primer nivel',
      distance: '4.2 km'
    },
    {
      id: 4,
      icon: 'Bus',
      title: 'Transporte Público',
      description: 'Rutas de buses y taxis disponibles',
      distance: '500 m'
    },
    {
      id: 5,
      icon: 'Utensils',
      title: 'Restaurantes',
      description: 'Variedad gastronómica arequipeña',
      distance: '1.5 km'
    },
    {
      id: 6,
      icon: 'Building2',
      title: 'Zona Financiera',
      description: 'Bancos y oficinas corporativas',
      distance: '3.0 km'
    }
  ];

  return (
    <section className="py-16 md:py-20 lg:py-24 bg-background">
      <div className="px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Map Column */}
          <div className="order-2 lg:order-1">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden elevation-3">
              <iframe
                width="100%"
                height="100%"
                loading="lazy"
                title="Ubicación Residencial 3 Volcanes en Arequipa"
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d25918.339528105535!2d-71.56582213747478!3d-16.326309991622487!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1ses-419!2spe!4v1768576767808!5m2!1ses-419!2spe"
                className="border-0"
              />
            </div>

            <div className="mt-6 p-6 rounded-xl bg-muted/50 border border-border">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="MapPin" size={24} color="var(--color-primary)" />
                </div>
                <div>
                  <h4 className="text-lg font-heading font-semibold text-foreground mb-2">
                    Dirección
                  </h4>
                  <p className="text-muted-foreground">
                    Bedoya II Etapa, Cerro Colorado<br />
                    Arequipa, Perú
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Column */}
          <div className="order-1 lg:order-2 space-y-8">
            <div>
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-6">
                <Icon name="MapPin" size={32} color="var(--color-primary)" />
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-4">
                Ubicación Estratégica en Arequipa
              </h2>
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
                Residencial 3 Volcanes está ubicado en una de las zonas más privilegiadas de Arequipa, 
                con acceso rápido a todos los servicios esenciales y vistas panorámicas incomparables.
              </p>
            </div>

            <div className="space-y-4">
              {locationFeatures?.map((feature) => (
                <div
                  key={feature?.id}
                  className="flex items-start space-x-4 p-4 rounded-xl hover:bg-muted/50 transition-smooth"
                >
                  <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name={feature?.icon} size={24} color="var(--color-primary)" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-1">
                      <h4 className="text-lg font-heading font-semibold text-foreground">
                        {feature?.title}
                      </h4>
                      <span className="text-sm font-medium text-primary whitespace-nowrap ml-4">
                        {feature?.distance}
                      </span>
                    </div>
                    <p className="text-muted-foreground">
                      {feature?.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="pt-4">
              <div className="p-6 rounded-xl bg-primary/5 border border-primary/20">
                <div className="flex items-center space-x-3 mb-3">
                  <Icon name="Mountain" size={24} color="var(--color-primary)" />
                  <h4 className="text-lg font-heading font-semibold text-foreground">
                    Vista a los 3 Volcanes
                  </h4>
                </div>
                <p className="text-muted-foreground">
                  Disfruta de vistas espectaculares del Misti, Chachani y Pichu Pichu desde tu hogar. 
                  Una experiencia única que solo Arequipa puede ofrecer.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;